<template>
  <div>
    <head-nav-bar
      title="实时房态"
      :fixed="true"
      rightText="筛选"
      @click-left="$router.push({ name: 'workplace' })"
      @click-right="onSearchClick"
    />
    <div class="mt-header-nav">
      <div class="search-area">
        <van-radio-group
          v-model="showType"
          :icon-size="16"
          direction="horizontal"
        >
          <van-radio name="1">平铺</van-radio>
          <van-radio name="2">房型</van-radio>
        </van-radio-group>
        <van-search
          placeholder="房号/客人姓名/手机号/备注"
          style="border-bottom:1px solid #f1f1f1;"
          v-model="searchData.keyWords"
          @search="onSearch"
          show-action
          shape="round"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>
      <div class="statistics-wraper">
        <Statistics :roomStatus="roomStatusColorData" @checked="onFilter" />
      </div>
      <div class="room-list" ref="mainContent">
        <div
          class="room-type"
          v-for="(item, index) in showRoomData"
          :key="index"
        >
          <div class="title" v-if="showType == 2">
            {{ item.RoomTypeName }} <small>￥{{ item.Price }}</small>
          </div>
          <van-grid :gutter="8" :column-num="3">
            <van-grid-item
              class="long"
              v-for="(dItem, dIndex) in item.Details"
              :key="dIndex"
              v-longpress="e => roomSetting(dItem)"
            >
              <div
                slot="default"
                class="room-item"
                :class="{ 'sm-room-item': isSmallView }"
              >
                <h5
                  class="room-no"
                  :style="'background:' + dItem.Color"
                  @click="checkRoomLog(dItem.Id)"
                  v-if="!isSmallView"
                >
                  {{ dItem.No
                  }}<span v-if="showType == 1">{{
                    dItem.RoomTypeShortName || dItem.RoomTypeName
                  }}</span>
                  <van-tag class="tag" round v-if="dItem.RoomCleanStatus === 0">
                    脏
                  </van-tag>
                </h5>
                <div
                  class="room-info empty"
                  :class="{ 'sm-room-info': isSmallView }"
                  :data-no="dItem.No"
                  :data-roomid="dItem.Id"
                  :data-roomname="dItem.RoomTypeName"
                  :data-roomTypeId="dItem.RoomTypeId"
                  :style="
                    'background:' +
                      (isSmallView ||
                      dItem.RoomStatus == 2 ||
                      dItem.RoomStatus == 3 ||
                      dItem.ColorExplain == '停用'
                        ? dItem.Color
                        : '')
                  "
                  @click="emptyChecked($event, dItem)"
                >
                  <van-icon class="check-icon" name="passed" />
                  <div v-if="isSmallView" class="sm-empty-cnt">
                    <van-tag
                      class="tag"
                      round
                      v-if="dItem.RoomCleanStatus === 0"
                    >
                      脏
                    </van-tag>
                    <span class="sm-room-no room-name">
                      {{ dItem.No
                      }}<span v-if="showType == 1">{{
                        dItem.RoomTypeShortName || dItem.RoomTypeName
                      }}</span>
                      <span
                        style="color:#fff"
                        v-if="dItem.RoomStatus == 2 || dItem.RoomStatus == 3"
                      >
                        -
                        {{
                          dItem.RoomStatusCalendarOutputs[0].RepairStatusName
                        }}
                      </span></span
                    >
                    <p
                      class="in-out-date"
                      v-if="dItem.RoomStatus == 2 || dItem.RoomStatus == 3"
                    >
                      {{ showRepairDateStr(dItem) }}
                    </p>
                  </div>
                  <div style="margin-top:0.1rem">
                    <span
                      style="color:#fff"
                      v-if="dItem.RoomStatus == 2 || dItem.RoomStatus == 3"
                    >
                      {{ dItem.RoomStatusCalendarOutputs[0].RepairReason }}
                    </span>
                    <span
                      style="color:#fff"
                      v-if="dItem.ColorExplain == '停用'"
                    >
                      已停用
                    </span>
                  </div>
                </div>
                <template v-for="(gItem, gIndex) in dItem.CalendarGuest">
                  <div
                    class="room-info"
                    :class="{ 'sm-room-info': isSmallView }"
                    :style="
                      'background:' +
                        (gItem.CustomColor ? gItem.CustomColor : gItem.Color)
                    "
                    :key="gIndex"
                    v-if="gIndex == 0"
                    @click="checkDetail(gItem)"
                  >
                    <div
                      v-if="isSmallView"
                      class="room-name"
                      :style="{
                        width: `calc(100% - ${
                          gItem.HasContacted && gItem.IsHourRoom
                            ? 28
                            : gItem.HasContacted || gItem.IsHourRoom
                            ? 14
                            : 0
                        }px )`,
                      }"
                    >
                      <van-tag
                        class="tag"
                        round
                        v-if="dItem.RoomCleanStatus === 0"
                      >
                        脏
                      </van-tag>
                      <span
                        v-if="gItem.LeavingArrow"
                        class="room-sign-icon room-sign-icon-leave"
                      >
                        <img :src="arrowRight" alt="" />
                      </span>
                      <van-icon
                        name="down"
                        class="room-sign-icon"
                        v-if="gItem.ArrivingArrow"
                      />
                      {{ dItem.No
                      }}<span v-if="showType == 1">{{
                        dItem.RoomTypeShortName || dItem.RoomTypeName
                      }}</span>
                    </div>
                    <span style="position: absolute; top: 5px; right: 2px;">
                      <van-icon
                        v-if="gItem.HasContacted"
                        name="friends-o"
                        size="15px"
                      />
                      <van-icon
                        v-if="gItem.IsHourRoom"
                        name="clock-o"
                        size="15px"
                      />
                    </span>
                    <div>
                      <span v-if="!isSmallView">
                        <span
                          v-if="gItem.LeavingArrow"
                          class="room-sign-icon room-sign-icon-leave"
                        >
                          <img :src="arrowRight" alt="" />
                        </span>
                        <van-icon
                          name="down"
                          class="room-sign-icon"
                          v-if="gItem.ArrivingArrow"
                        />
                      </span>
                      <van-tag class="tag" v-if="gItem.MemberCardNo">{{
                        defaultItem.Member ? defaultItem.Member : "卡"
                      }}</van-tag>
                      <van-tag class="tag" v-if="gItem.CustomerName">{{
                        defaultItem.Customer ? defaultItem.Customer : "客"
                      }}</van-tag>
                      <van-tag class="tag" v-if="gItem.ChanelName">{{
                        defaultItem.Channel
                          ? defaultItem.Channel
                          : gItem.ChanelName.slice(0, 1)
                      }}</van-tag>
                      {{ gItem.GuestName }}
                    </div>
                    <p class="in-out-date">{{ showDateStr(gItem) }}</p>
                  </div>
                </template>
              </div>
            </van-grid-item>
          </van-grid>
        </div>
      </div>
    </div>
    <div class="operation" v-if="isEmptyRoomCheck">
      <van-button type="default" @click="clearDate">取消选中</van-button>
      <van-button type="primary" @click="roomOrder('order', 2)"
        >预定</van-button
      >
      <van-button type="info" @click="roomOrder('checkin', 2)">入住</van-button>
    </div>
    <roomUpdate
      :visible.sync="visible.roomUpdate"
      :option="roomInfo"
      fromUrl="TodayRoom"
      :defaultItem="defaultItem"
      @update="getRoomData"
    ></roomUpdate>
  </div>
</template>

<script>
import "./todayRoom.less";
import moment from "moment";
import RoomUpdate from "./roomComponent/RoomUpdate.vue";
import {
  Icon,
  Grid,
  GridItem,
  Search,
  Tag,
  Button,
  RadioGroup,
  Radio,
  Sticky,
} from "vant";
import roomApi from "../../api/room.js";
import { mixin } from "./mixin";
import arrowRight from "@/assets/images/arrow-right.png";
import { mapState, mapActions } from "vuex";
import Statistics from "./Statistics.vue";
import cloneDeep from "lodash/cloneDeep";
export default {
  components: {
    [Icon.name]: Icon,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Search.name]: Search,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Sticky.name]: Sticky,
    RoomUpdate,
    Statistics,
  },
  mixins: [mixin],
  data() {
    return {
      arrowRight,
      roomData: [],
      priceData: [],
      priceDataObj: {},
      roomInfo: {},
      isEmptyRoomCheck: false,
      disabled: {
        reserve: true,
        checkIn: true,
      },
      isShowLeaving: "1",
      roomList: [],
      showType: "1",
      showRoomData: [],
      roomStatusColorData: [],
      baseData: [],
    };
  },
  computed: {
    ...mapState({
      roomStatusShowType: state => state.room.roomStatusShowType,
    }),
    showDateStr() {
      return function(item) {
        return (
          moment(item.CheckInTime).format("MM/DD") +
          "-" +
          moment(item.CheckOutTime).format("MM/DD")
        );
      };
    },
    showRepairDateStr() {
      return function(item) {
        return (
          moment(item.RoomStatusCalendarOutputs[0].RepairBeginTime).format(
            "MM/DD",
          ) +
          "-" +
          moment(item.RoomStatusCalendarOutputs[0].RepairEndTime).format(
            "MM/DD",
          )
        );
      };
    },
  },
  watch: {
    showType(val) {
      this.setRoomStatusShowType(val);
      this.searchData.keyWords = "";
      this.searchData.roomType = "";
      this.getRoomData();
    },
  },
  mounted() {
    this.showType = this.roomStatusShowType;
    Promise.all([this.getDefaultItem(), this.getSearchSelectData()]).then(
      () => {
        this.getRoomPrice();
      },
    );
  },
  methods: {
    ...mapActions(["setRoomStatusShowType"]),
    /**关键字搜索 */
    onSearch() {
      const keyWords = this.searchData.keyWords.trim();
      const roomType = this.searchData.roomType;
      const data = cloneDeep(this.baseData);
      let filterData = [];
      if (!keyWords && !roomType) {
        filterData = data;
        this.setRoomData(filterData);
        return;
      }
      let list = [],
        ids = [];
      data.forEach(el => {
        let isPush = true;
        if (roomType && el.RoomTypeId != roomType) {
          isPush = false;
        }
        if (isPush && keyWords) {
          if (el.No.includes(keyWords)) {
            list.push(el);
            ids.push(el.Id);
          } else if (
            el.RoomStatusCalendarOutputs &&
            el.RoomStatusCalendarOutputs.length
          ) {
            const item =
              (el.RoomStatusCalendarOutputs[0].CalendarGuestDetails || [])[0] ||
              {};

            if (
              ((item.GuestName || "").includes(keyWords) ||
                (item.Phone || "").includes(keyWords) ||
                (item.Remark || "").includes(keyWords)) &&
              !ids.includes(el.Id)
            ) {
              list.push(el);
              ids.push(el.Id);
            }
          }
        } else if (!keyWords && isPush) {
          list.push(el);
          ids.push(el.Id);
        }
      });
      filterData = list;
      this.setRoomData(filterData);
    },
    onFilter(item) {
      this.searchData = {
        roomType: "",
        roomStatus: item.Value,
        keyWords: "",
      };
      this.getRoomData();
    },
    onSearchClick() {
      this.getSearchPopup(2);
    },
    /**搜索房型和房间状态 */
    handleSearch(values) {
      this.isShowLeaving = values.isShowLeaving;
      this.setSearchValue(values);
    },
    /**获取今日房价 */
    getRoomPrice() {
      roomApi
        .GetRoomPrice({
          CheckInDate: this.user.AccountDate,
          CheckOutDate: this.user.AccountDate,
        })
        .then(res => {
          this.priceData = res.Data;
          const obj = {};
          this.priceData.forEach(el => {
            obj[el.RoomTypeId] = el;
          });
          this.priceDataObj = obj;
          this.getRoomData();
        });
    },
    /**获取今日房态数据 */
    getRoomData(callback) {
      this.clearDate();

      const json = {
        StartDate: this.user.AccountDate,
        EndDate: this.user.AccountDate,
        IsShowLeaving: this.isShowLeaving == "0" ? false : true,
        // RoomTypeId: this.searchData.roomType,
        RoomStatusType: this.searchData.roomStatus,
        SortModel: this.showType == 1 ? 1 : 0,
        IsOneColor: this.isSmallView,
      };
      if (this.searchData.keyWords && this.searchData.keyWords.trim()) {
        json.KeyWords = this.searchData.keyWords.trim();
      }
      roomApi.GetRoomStatus(json).then(res => {
        this.baseData = cloneDeep(res.Data.RoomNoStatuses);
        this.roomColorCountObj = res.Data.TodayRoomStatusCount;
        this.setRoomData(res.Data.RoomNoStatuses);
        this.getRoomStatusColor();
        callback && callback();
      });
    },
    setRoomData(roomNoStatuses) {
      const _this = this;
      var result = [];
      roomNoStatuses.forEach(function(v, i) {
        const obj = {
          RoomTypeId: v.RoomTypeId,
          RoomTypeName: v.RoomTypeName,
          Details: [v],
        };
        // let priceResult = _this.priceData.find(
        //   item => item.RoomTypeId === v.RoomTypeId
        // );
        if (_this.priceDataObj[v.RoomTypeId]) {
          obj.Price = _this.priceDataObj[v.RoomTypeId].Price;
        }
        var lastDetails =
          result[result.length - 1] && result[result.length - 1].Details;
        if (!i) {
          result.push(obj);
        } else if (result[result.length - 1].RoomTypeId === v.RoomTypeId) {
          lastDetails.push(v);
        } else {
          result.push(obj);
        }
      });
      this.roomData = result.map(el => {
        el.Details.forEach(ele => {
          if (
            ele.RoomStatusCalendarOutputs &&
            ele.RoomStatusCalendarOutputs.length
          ) {
            ele.CalendarGuest =
              ele.RoomStatusCalendarOutputs[0].CalendarGuestDetails;
          }
        });
        return el;
      });

      this.roomList = [
        {
          Details: roomNoStatuses.map(ele => {
            if (
              ele.RoomStatusCalendarOutputs &&
              ele.RoomStatusCalendarOutputs.length
            ) {
              ele.CalendarGuest =
                ele.RoomStatusCalendarOutputs[0].CalendarGuestDetails;
            }
            return ele;
          }),
        },
      ];
      if (this.showType == 1) {
        this.showRoomData = this.roomList;
      } else {
        this.showRoomData = this.roomData;
      }
    },
    // 获取房间状态色值
    getRoomStatusColor() {
      const data = cloneDeep(this.baseRoomStatusColorData);
      let obj = {};
      this.roomStatusData.forEach(el => {
        obj[el.Code] = el;
      });
      data.forEach(v => {
        v.count = this.roomColorCountObj[v.Code];
        v.Value = obj[v.Code].Id;
        if (v.Code == "Arrivals") {
          v.count = this.roomColorCountObj["Arriving"];
        } else if (v.Code == "Departure") {
          v.count = this.roomColorCountObj["Leaving"];
        }
      });
      data.splice(0, 0, {
        Color: "url(/image/colorall.png)",
        Data: {
          Color: "url(/image/colorall.png)",
        },
        Code: "All",
        Text: "全部",
        count: this.roomColorCountObj.Total,
      });
      this.roomStatusColorData = data;
    },
    /**选择空房 */
    emptyChecked(e, item) {
      if (
        item.ColorExplain == "停用" ||
        item.RoomStatus == 2 ||
        item.RoomStatus == 3
      ) {
        return;
      }
      if (this.$common.hasClass(e.currentTarget, "room-checked")) {
        this.$common.removeClass(e.currentTarget, "room-checked");
      } else {
        this.$common.addClass(e.currentTarget, "room-checked");
      }
      let roomCheckedObj = this.$refs.mainContent.querySelectorAll(
        ".room-checked",
      );
      const AccountDate = this.user.AccountDate;
      let roomCheckedArr = [...roomCheckedObj];
      var result = [];
      roomCheckedArr.forEach(function(v) {
        const obj = {
          roomId: v.dataset.roomid,
          roomNo: v.dataset.no,
          roomTypeId: v.dataset.roomtypeid,
          roomTypeName: v.dataset.roomname,
          date: [AccountDate],
        };
        result.push(obj);
      });
      this.checkedDateArray = result;
      this.isEmptyRoomCheck = roomCheckedObj.length;
    },
  },
};
</script>
<style lang="less" scoped>
.search-area {
  display: flex;
  /deep/.van-radio-group {
    display: flex;
    min-width: 115px;
    font-size: 13px;
    .van-radio {
      margin: 3px;
    }
  }
}
</style>
